import { render, staticRenderFns } from "./svg-sedan.vue?vue&type=template&id=0c9d393c&scoped=true"
import script from "./svg-sedan.vue?vue&type=script&setup=true&lang=ts"
export * from "./svg-sedan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./svg-sedan.vue?vue&type=style&index=0&id=0c9d393c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d393c",
  null
  
)

export default component.exports